module.exports = __webpack_public_path__ + "img/22_23.425d97ae.png";